import React from 'react';
import { Link } from 'react-router-dom';
import { AppDownloadButtons } from './AppDownloadButtons';
import { format } from 'date-fns';
import { RefreshCw } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-4">
            Trusted by leading organizations
          </h3>
          
          <div className="mb-6">
            <a 
              href="https://gentlebirth.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xl font-bold text-primary hover:text-primary/80 transition-colors duration-200"
            >
              GentleBirth
            </a>
            <p className="text-muted-foreground text-sm mt-2">
              SleepNest adopts all privacy policies of Gentlebirth.
            </p>
          </div>
          
          <div className="flex items-center justify-center space-x-4 text-sm mb-6">
            <Link 
              to="/privacy" 
              className="text-primary hover:text-primary/80 transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <span className="text-muted-foreground">•</span>
            <Link 
              to="/terms" 
              className="text-primary hover:text-primary/80 transition-colors duration-200"
            >
              Terms & Conditions
            </Link>
          </div>
          
          {/* Mobile App Downloads */}
          <div className="mt-6 pt-6 border-t border-slate-200 dark:border-slate-800">
            <p className="text-sm font-medium text-slate-700 dark:text-slate-300 mb-4">
              Mobile App for Parents & Caregivers
            </p>
            <AppDownloadButtons />
          </div>

          {/* Last Updated & Refresh */}
          <div className="mt-6 pt-4 border-t border-slate-200 dark:border-slate-800 flex items-center justify-center gap-3">
            <p className="text-xs text-muted-foreground">
              Last updated: {format(new Date(), 'MMMM d, yyyy \'at\' h:mm a')}
            </p>
            <button
              onClick={async () => {
                // Clear all caches and reload
                if ('caches' in window) {
                  const cacheNames = await caches.keys();
                  await Promise.all(cacheNames.map(name => caches.delete(name)));
                }
                // Clear service worker registrations
                if ('serviceWorker' in navigator) {
                  const registrations = await navigator.serviceWorker.getRegistrations();
                  await Promise.all(registrations.map(r => r.unregister()));
                }
                // Hard reload
                window.location.reload();
              }}
              className="p-1.5 rounded-full hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors text-muted-foreground hover:text-foreground"
              title="Clear cache and refresh"
            >
              <RefreshCw className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}